import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration } from 'actions/Site'
import {
  fetchDetailUser, resendEmail, updateDateDetail, downloadUserDocument, fetchUserCertificate,
} from 'actions/User'
import { fetchProfileList } from 'actions/UpdateProfile'
import DetailUserView from 'components/pages/users/detail'
import { message } from 'antd'
import moment from 'moment'

export function mapStateToProps(state) {
  const {
    isFetching,
    detailUser,
  } = state.root.user
  const { currentUser } = state.root.auth

  return {
    currentUser,
    isFetching,
    detailUser,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  fetchDetailUser: bindActionCreators(fetchDetailUser, dispatch),
  resendEmail: bindActionCreators(resendEmail, dispatch),
  updateDateDetail: bindActionCreators(updateDateDetail, dispatch),
  downloadUserDocument: bindActionCreators(downloadUserDocument, dispatch),
  fetchProfileList: bindActionCreators(fetchProfileList, dispatch),
  fetchUserCertificate: bindActionCreators(fetchUserCertificate, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  // which inline field is being edited: null | 'dob' | 'email'
  withState('editingField', 'setEditingField', null),
  withState('isSubmit', 'setIsSubmit', {
    resendEmail: false,
    resendPin: false,
  }),
  withState('isSubmitEdit', 'setIsSubmitEdit', false),
  withState('isDownloading', 'setIsDownloading', {
    ktp: false,
    npwp: false,
  }),
  // Kartu Peserta (QR, VA, tanggal kepesertaan); null when account not active
  withState('certificate', 'setCertificate', { data: null, isFetching: false }),
  // Riwayat pengajuan perubahan data (Pengkinian Data) milik member ini
  withState('profileHistory', 'setProfileHistory', {
    data: [],
    meta: {},
    isFetching: false,
  }),
  withHandlers({
    handleResend: props => (params) => {
      props.resendEmail(params)
        .then(() => {
          message.success('Email was successfully resent')
          props.setIsSubmit({
            resendEmail: false,
            resendPin: false,
          })
        })
        .catch(() => {
          props.setIsSubmit({
            resendEmail: false,
            resendPin: false,
          })
        })
    },
  }),
  withHandlers({
    fetchCertificate: props => () => {
      const { match, setCertificate } = props
      setCertificate({ data: null, isFetching: true })
      props.fetchUserCertificate(match.params.id)
        .then(data => setCertificate({ data, isFetching: false }))
        .catch(() => setCertificate({ data: null, isFetching: false })) // 404 = belum aktif, hide card
    },
    // Needs manage-pengkinian-data-read; skip silently when the admin lacks it
    fetchProfileHistory: props => (page = 1) => {
      const { currentUser, match, setProfileHistory } = props
      const canReadHistory = currentUser.permissions && currentUser.permissions.indexOf('manage-pengkinian-data-read') > -1
      if (!canReadHistory || !match.params.id) return
      setProfileHistory(prev => ({ ...prev, isFetching: true }))
      props.fetchProfileList(`?account_id=${match.params.id}&page=${page}&limit=10`)
        .then((result) => {
          setProfileHistory({
            data: result.data || [],
            meta: result.meta || {},
            isFetching: false,
          })
        })
        .catch(() => {
          setProfileHistory({
            data: [],
            meta: {},
            isFetching: false,
          })
        })
    },
  }),
  withHandlers({
    handleProfileHistoryPage: props => (page) => {
      props.fetchProfileHistory(page)
    },
    handleStartEdit: props => (field) => {
      props.setEditingField(field)
    },
    handleCancelEdit: props => () => {
      props.setEditingField(null)
    },
    // Inline submit for a single field. Backend update-partial requires
    // email + birthdate + birthplace together, so untouched fields resend existing values.
    handleSubmitField: props => (values) => {
      const {
        match, detailUser, setIsSubmitEdit, setEditingField,
      } = props
      setIsSubmitEdit(true)

      const birthdate = values.birthdate
        ? moment(values.birthdate).format('YYYY-MM-DD')
        : (detailUser.dob || '')

      const payload = {
        email: values.email !== undefined ? values.email : (detailUser.email || ''),
        birthdate,
        birthplace: detailUser.birth_place || '',
      }

      props.updateDateDetail(match.params.id, payload)
        .then(() => {
          message.success('Data has been updated')
          setEditingField(null)
          setIsSubmitEdit(false)
          props.fetchDetailUser(match.params.id)
        }).catch((err) => {
          setIsSubmitEdit(false)
          message.error(err)
        })
    },
    handleDownloadDocument: props => (type) => {
      const {
        match, detailUser, isDownloading, setIsDownloading,
      } = props
      setIsDownloading({ ...isDownloading, [type]: true })

      props.downloadUserDocument(match.params.id, type)
        .then((response) => {
          const FileSaver = require('file-saver') // eslint-disable-line global-require
          const contentType = response.headers['content-type'] || 'application/octet-stream'
          const ext = contentType.indexOf('png') > -1 ? 'png' : 'jpg'
          const blob = new Blob([response.data], { type: contentType })
          FileSaver.saveAs(blob, `${type.toUpperCase()}_${detailUser.registered_number || match.params.id}.${ext}`)
          setIsDownloading({ ...isDownloading, [type]: false })
        })
        .catch((err) => {
          message.error(err || 'Failed to download document')
          setIsDownloading({ ...isDownloading, [type]: false })
        })
    },
    handleResendEmail: props => () => {
      props.setIsSubmit({ resendEmail: true })
      props.handleResend({
        event: 'approve-user-email',
        user_id: props.match.params.id,
      })
    },
    handleResendEmailPin: props => () => {
      props.setIsSubmit({ resendPin: true })
      props.handleResend({
        event: 'forgot-pin-email',
        user_id: props.match.params.id,
      })
    },
  }),
  lifecycle({
    componentDidMount() {
      const { match } = this.props
      this.props.updateSiteConfiguration('breadList', ['Home', 'Member Management', 'Detail'])
      this.props.updateSiteConfiguration('titlePage', 'Detail Member')
      if (match.params.id) {
        this.props.fetchDetailUser(match.params.id)
        this.props.fetchCertificate()
        this.props.fetchProfileHistory(1)
      }
    },
  }),
)(DetailUserView)
